<template>
  <div class="relative w-full">
    <zt-chip
      v-if="value"
      square
      closable
      close-icon="close-rounded"
      color="primary-100"
      @click:close="clearChip"
      class="p-3"
      ref="chipWrapper"
      data-vs-chip="clearChip"
    >
      {{ value.name }}
      <div
        v-show="showDeleteBox"
        ref="warningDeleteBox"
        class="absolute bg-white rounded position-box box-deleted p-4 flex flex-column"
        :style="cordsDeleteBox"
      >
        <p class="font-medium mb-3">{{ $t('message.abm.folders.toolbox.deletePdf') }}</p>
        <p class="text-zt-dark-300 text-zt-base">{{ $t('message.abm.folders.toolbox.questionPdf') }}</p>
        <p class="text-zt-dark-300 text-zt-base">{{ $t('message.abm.folders.toolbox.notUndo') }}</p>
        <div class="flex justify-end h-full items-end">
          <zt-button text style="color: #4a4a4a !important;" class="text-zt-base" @click="closeBoxDelete" data-vs-button="closeBoxDelete">
            {{ $t('message.abm.folders.toolbox.cancel') }}
          </zt-button>
          <zt-button class="text-zt-base ml-2" @click="clearPDF" data-vs-button="clearPDF">
            {{ $t('message.abm.folders.toolbox.confirmDelete') }}
          </zt-button>
        </div>
      </div>
    </zt-chip>
    <zt-button
      v-else
      icon="box-arrow-top"
      outlined
      :loaderTxt="$t('message.abm.folders.toolbox.loading')"
      :loader="isLoading"
      @click="$refs.inputFile.click()"
      data-vs-button="inputFileClick"
    >
      {{label}}
      <input hidden type="file" :accept="filetypes" ref="inputFile" @change="handleFileChange" data-vs-input="inputFile" />
    </zt-button>
  </div>
</template>
<script>
export default {
  name: 'InputFileUpload',
  props: {
    filetypes: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Array, Object, File, String, Event],
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: '',
      showDeleteBox: false,
      cordsDeleteBox: {}
    }
  },
  watch: {
    showDeleteBox() {
      if(this.showDeleteBox) {
        this.insertContent(this.$refs.warningDeleteBox)
      }
    }
  },
  methods: {
    handleFileChange(e) {
      this.file = e.target.files[0]
      this.$emit('input-file', this.file)
    },
    clearPDF(){
      this.$emit('input-file-clear')
      this.closeBoxDelete()
    },
    clearChip() {
      this.showDeleteBox = true
      this.$nextTick(() => {
        this.cordsDeleteBox = this.positionBox()
      })
    },
    closeBoxDelete() {
      this.showDeleteBox = false
      this.deleteContent()
    },
    insertContent(elz) {
      let content = document.body
      content.insertBefore(elz, content.firstChild)
    },
    deleteContent() {
      let [parent] = document.getElementsByTagName('body')
      if (
          parent &&
          this.$refs.warningDeleteBox &&
          this.$refs.warningDeleteBox.parentNode === parent
      ) {
        parent.removeChild(this.$refs.warningDeleteBox)
      }
    },
    positionBox() {
      let chipWrapper = this.$refs['chipWrapper'].$el
      let scrollContentTop = window.pageYOffset || document.documentElement.scrollTop
      let topPos = chipWrapper.getBoundingClientRect().top
          + scrollContentTop - chipWrapper.clientHeight
      let leftPost = chipWrapper.getBoundingClientRect().right + 12
      return {
        left: `${leftPost}px`,
        top: `${topPos}px`
      }
    }
  },
  beforeDestroy() {
    this.deleteContent()
  }
}
</script>

<style scoped lang="scss">
.position-box {
  width: 350px;
  height: 176px;
  z-index: 9999;
  box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -webkit-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -moz-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
}
.box-deleted:after {
  content: "";
  background: inherit;
  width: 16px;
  height: 16px;
  position: absolute;
  display: block;
  left: -14px;
  transform: rotate(45deg) translateY(-50%);
  top: 25%;
  border-left: 1px solid #D0D0D0FF;
  border-bottom: 1px solid #D0D0D0FF;
}
::v-deep {
  .zt-chip {
    overflow: visible;
    background: #C4C6FF;
    border: solid 1px #4F41A3;
    padding: 1rem !important;
    .zt-chip-text {
      color: #4F41A3;
      font-size: 1.25rem;
    }
    .zt-chip-close {
      color: rgba(0, 0, 0, 0.6);
    }
  }
}
</style>